'use client';
import { PublicPropertySaveProvider } from '~/components/parcel-watch/public-property-save';
import { useState, type ReactNode } from 'react';
import { NextIntlClientProvider } from 'next-intl';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { SiteTheme } from './site-theme';
import { TooltipProvider } from './ui/tooltip';
import { Toaster } from './ui/sonner';
import parcelWatch from '~/i18n/messages/en/parcelWatch.json';
import onboarding from '~/i18n/messages/en/onboarding.json';
import legal from '~/i18n/messages/en/legal.json';
export function Providers({ children }: { children: ReactNode }) {
  const [query] = useState(
    () => new QueryClient({ defaultOptions: { queries: { retry: false } } }),
  );
  return (
    <NextIntlClientProvider
      locale="en"
      timeZone="America/Los_Angeles"
      messages={{ parcelWatch, onboarding, legal }}
    >
      <SiteTheme>
        <QueryClientProvider client={query}>
          <TooltipProvider>
            <PublicPropertySaveProvider>{children}</PublicPropertySaveProvider>
            <Toaster />
          </TooltipProvider>
        </QueryClientProvider>
      </SiteTheme>
    </NextIntlClientProvider>
  );
}
